// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vSYTe","importantInfo":"styles_importantInfo__3rFxP"};